// ----------------
// UI Modules
// ----------------
// This is for UI modules
// ---------------------------------------------------------------
// End import
import globalJS from './global'
import pagesJS from './pages'

function init() {
    globalJS()
    pagesJS()
}

export default init



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/index.js